import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";
import type { ChatMessage } from "./chatApi";

export interface VoiceChatResponse {
  transcript: string;
  message: ChatMessage;
  /** Base64-encoded Opus audio of the assistant reply (gpt-4o-mini-tts). */
  response_audio_base64?: string;
  /** True when TTS failed; frontend can show "text only" or play button disabled. */
  tts_error?: boolean;
}

export async function sendVoiceMessage(
  audio: Blob,
  messages: ChatMessage[]
): Promise<VoiceChatResponse> {
  const formData = new FormData();
  formData.append("audio", audio, "audio.webm");
  formData.append("messages", JSON.stringify(messages));

  const { data } = await axios.post<VoiceChatResponse>(
    `${API_BASE_URL}/voice-chat/`,
    formData,
    {
      withCredentials: true,
    }
  );

  return data;
}

